import React from "react";
import {
  View,
  Modal,
  StyleSheet,
  TouchableOpacity,
  ActivityIndicator,
} from "react-native";
import Text from "@components/CustomText";

const CancelOrReopenDialog = ({
  visible,
  onRequestClose = () => {},
  title,
  message,
  buttons,
}) => (
  <Modal visible={visible} onRequestClose={onRequestClose} transparent>
    <View
      style={{
        flex: 1,
        backgroundColor: "rgba(0,0,0,0.4)",
        alignItems: "center",
        justifyContent: "center",
        elevation: 2,
      }}
    >
      <View style={styles.dialogContainer}>
        <Text variant="title_18_semi">{title}</Text>
        <Text
          variant="body_text_3"
          style={{ color: "#757575", marginVertical: 16 }}
        >
          {message}
        </Text>
        <View style={styles.dialogButtonContainer}>
          {buttons.map((button) => (
            <TouchableOpacity onPress={button.onPress} key={button.text}>
              <Text
                variant="body_text_4"
                style={[styles[button.style], { padding: 6 }]}
              >
                {button.text}
              </Text>
            </TouchableOpacity>
          ))}
        </View>
      </View>
    </View>
  </Modal>
);

export default CancelOrReopenDialog;

const styles = StyleSheet.create({
  cancel: {
    color: "rgba(0, 0, 0, 0.56)",
    marginRight: 40,
  },
  okay: { color: "#E40046" },
  dialogButtonContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-end",
    marginVertical: 10,
  },
  dialogContainer: {
    backgroundColor: "white",
    width: "90%",
    paddingHorizontal: 24,
    borderRadius: 10,
    paddingVertical: 25,
    paddingBottom: 10,
  },
});
